import Aboutme from '../../Components/AboutMe/Aboutme';
import BackToTop from '../../Components/BackToTop/BackToTop';
import ContactSection from '../../Components/Contact/ContactSection';
import Education from '../../Components/Education/Education';
import Experience from '../../Components/Experience/Experience';
import Footer from '../../Components/Footer/Footer';
import HomeHero from '../../Components/HomeHero/HomeHero';
import Impact from '../../Components/Impact/Impact';
import ProjectsSection from '../../Components/Projects/ProjectsSection';
import Skills from '../../Components/Skills/Skills';
import useHashScroll from '../../hooks/useHashScroll';

const Home = () => {
  useHashScroll();

  return (
    <main id="main-content" className="pb-16 md:pb-0">
      <HomeHero />
      <Aboutme />
      <Experience />
      <Education />
      <Skills />
      <ProjectsSection />
      <Impact />
      <ContactSection />
      <Footer />
      <BackToTop />
    </main>
  );
};

export default Home;